// Application types

const ROLES = {
  STORING: "STORING",
  ASSIGNING: "ASSIGNING",
  LOADING_ROLES: "LOADING_ROLES",
  GET_ALL_ROLES: "GET_ALL_ROLES",
  GET_A_ROLE: "GET_A_ROLE",
  STORE_A_ROLE: "STORE_A_ROLE",
};

export default ROLES;
